import { render, staticRenderFns } from "./UnsolicitedItems.vue?vue&type=template&id=5db5a21c&scoped=true&"
import script from "./UnsolicitedItems.vue?vue&type=script&lang=js&"
export * from "./UnsolicitedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5a21c",
  null
  
)

export default component.exports